import type { GridTableContentSection } from 'components/GridTable/types'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const regionLacksPermissionSectionMaker = ({
  id,
  regionId = String(selectedFieldAssetsStore.getState().region),
  title,
  titleToggle,
  titleLink,
  fieldAssetPicker,
}: {
  id: StackedChartSection['id'] & GridTableContentSection['id']
  regionId?: string
  title: StackedChartSection['title'] & GridTableContentSection['title']
  titleToggle?: StackedChartSection['titleToggle'] & GridTableContentSection['titleToggle']
  titleLink?: StackedChartSection['titleLink'] & GridTableContentSection['titleLink']
  fieldAssetPicker: StackedChartSection['fieldAssetPicker'] & GridTableContentSection['fieldAssetPicker']
}): StackedChartSection & GridTableContentSection => {
  const regionName =
    fieldAssetStore.getState()?.regions?.[regionId]?.name ?? translate.phrases.banyanApp('Unknown Region')

  return {
    id,
    title,
    titleToggle,
    titleLink,
    items: [],
    fieldAssetPicker,
    fullWidthItems: [
      {
        height: 150,
        content: (
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {translate.phrases.banyanApp('You do not have access to this feature for {{propertyName}}', {
              propertyName: regionName,
            })}
          </div>
        ),
      },
    ],
    defaultCollapsed: true,
  }
}
